import createDataContext from "./createDataContext";

// Alert Reducer Context and Provider
const alertReducer = (state, { type, payload }) => {
  switch (type) {
    case "SET_ALERT":
      return payload;
    case "CLEAR_ALERT":
      return {};
    default:
      return state;
  }
};

const setAlert =
  (dispatch) =>
  (message, variant = "danger") => {
    dispatch({ type: "SET_ALERT", payload: { message, variant } });
  };

const clearAlert = (dispatch) => () => {
  dispatch({ type: "CLEAR_ALERT" });
};

export const {
  Provider: AlertProvider,
  StateContext: AlertState,
  ActionsContext: AlertActions,
  useStateContext: useAlertState,
  useActionsContext: useAlertActions,
} = createDataContext(alertReducer, { setAlert, clearAlert }, {});
